export const mockcontractsigningyes = {
    error: false,
    data: {
        leadId: "2Kb0gs231ADSZXC",
        message: "Documento firmado exitosamente",
        quoteId: "DS1234CXZASD43asd",
        ApplicationId: 123456
    }
}

export const mockcontractsigningno = {
    error: false,
    data: {
        leadId: "2Kb0gs231ADSZXC",
        message: "No acepta terminos contrato inquilino",
        quoteId: "DS1234CXZASD43asd",
        ApplicationId: 123456
    }
}

export const mockcontractsign404 = {
    data: {
        quoteId: "0Q0dq0000004lwPCAQ",
        message: "Error 400 del servidor",
        leadId: "2Kb0gs231ADSZXC",
        ApplicationId: 3945751
    },
    error: true
}







